import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";

export default function Messages() {
  const [params, setParams] = useSearchParams();
  const token = params.get("token") || "";
  const [input, setInput] = useState(token);
  const [items, setItems] = useState(null);
  const [err, setErr] = useState("");

  async function fetchMessages(tk) {
    setErr("");
    try {
      const { data } = await api.get("/admin/messages", { params: { token: tk } });
      setItems(data.items || []);
    } catch (e) {
      setErr(e?.response?.data?.detail || "Unauthorized");
      setItems(null);
    }
  }

  useEffect(() => {
    if (token) fetchMessages(token);
  }, [token]);

  return (
    <div className="App">
      <Header compact />

      <main className="max-w-3xl mx-auto px-6 pt-8 pb-24">
        <h1 className="font-display text-3xl sm:text-4xl font-semibold text-[#1a1640]" data-testid="messages-title">
          Contact Messages
        </h1>
        <p className="mt-2 text-[#6b6894] text-[15px]">Private inbox — enter admin token to view</p>

        {!items && (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              setParams({ token: input });
            }}
            className="mt-6 flex flex-wrap gap-2 bg-white rounded-[18px] p-4 shadow-sm"
          >
            <input
              type="password"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="admin token"
              className="flex-1 min-w-[220px] rounded-xl border border-slate-200 bg-[#faf7ea] px-3 py-2 text-[14px] outline-none focus:border-indigo-400"
              data-testid="messages-token-input"
            />
            <button type="submit" className="myneta-btn" style={{ padding: "10px 16px", fontSize: 13 }} data-testid="messages-load-btn">
              Load
            </button>
          </form>
        )}

        {err && (
          <div className="mt-4 text-rose-600 font-semibold text-sm" data-testid="messages-error">
            {err}
          </div>
        )}

        {items && items.length === 0 && (
          <div className="mt-6 bg-white rounded-[22px] p-8 text-center text-[#6b6894]" data-testid="messages-empty">
            No messages yet.
          </div>
        )}

        {items && items.length > 0 && (
          <div className="mt-6 space-y-3" data-testid="messages-list">
            <div className="text-[12px] uppercase tracking-widest text-[#6b6894] font-semibold">
              {items.length} message{items.length === 1 ? "" : "s"}
            </div>
            {items.map((m) => (
              <article
                key={m.id}
                className="bg-white rounded-[18px] p-5 shadow-sm border-l-4 border-indigo-500"
                data-testid={`message-${m.id}`}
              >
                <header className="flex flex-wrap items-baseline gap-x-3 gap-y-1 text-sm">
                  <span className="font-semibold text-[#1a1640]">{m.contact_id}</span>
                  <a
                    href={`mailto:${m.email}`}
                    className="text-indigo-700 underline hover:text-indigo-900"
                  >
                    {m.email}
                  </a>
                  <span className="text-[#8c89ad] text-xs ml-auto">
                    {new Date(m.created_at).toLocaleString()}
                  </span>
                </header>
                <p className="mt-3 text-[15px] text-[#1a1640] whitespace-pre-wrap">{m.message}</p>
              </article>
            ))}
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
}
